import { createSelector } from 'reselect'

const getHomeData = state => state.home.data

export const selectHomeId = createSelector(
  getHomeData,
  home => (home ? home.id : undefined)
)
